export const HEADER_HEIGHT = '64px'
export const FOOTER_HEIGHT = '88px'
export const FOOTER_HEIGHT_SP = '116px'

export const SCREEN_WIDTH = 394
export const SCREEN_HEIGHT = 245
